import React from 'react';
import { createRoot } from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.css"
import './index.css';
import RoutesComponent from './components/Routes'

let tema = localStorage.getItem("tema")

if(tema === "white-content"){
  document.body.classList.add("white-content")
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <RoutesComponent />
  </React.StrictMode>
);
